export const DOWNLOAD_APP = "Download our app";
export const ABOUT_US = "About us";
export const CONTACT_US = "Contact Us";
export const FAQs = "FAQs";
